module.exports = __webpack_public_path__ + "static/media/pro2.cc03d52b.png";